var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardLinkSupportPunish(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.0392 3.9704C30.4541 0.399148 25.2993 0 19 0C12.6927 0 7.53007 0.40375 3.9465 3.98465C0.363448 7.56406 0 12.7184 0 19.0184C0 25.3195 0.363448 30.4754 3.94798 34.0561C7.53133 37.6375 12.6934 38 19 38C25.3066 38 30.4678 37.6375 34.0511 34.0561C37.6354 30.4748 37.9999 25.3195 37.9999 19.0184C37.9999 12.7103 37.6315 7.55041 34.0392 3.9704Z",
    fill: "#ABB6CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.24 24.7499H25.16C25.07 24.8299 24.98 24.8999 24.89 24.9799L20.62 28.1799C19.21 29.2299 16.91 29.2299 15.49 28.1799L11.21 24.9799C10.27 24.2799 9.5 22.7299 9.5 21.5599V14.1499C9.5 12.9299 10.43 11.5799 11.57 11.1499L16.55 9.27986C17.37 8.96986 18.73 8.96986 19.55 9.27986L24.52 11.1499C25.47 11.5099 26.28 12.5099 26.53 13.5299H19.23C19.01 13.5299 18.81 13.5399 18.62 13.5399C16.77 13.6499 16.29 14.3199 16.29 16.4299V21.8598C16.3 24.1598 16.89 24.7499 19.24 24.7499Z",
    stroke: "#2D4982",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 18.22H29.5",
    stroke: "#2D4982",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 16.4198V21.9698C29.48 24.1898 28.87 24.7397 26.56 24.7397H19.2401C16.8901 24.7397 16.3 24.1498 16.3 21.8398V16.4098C16.3 14.3098 16.7801 13.6397 18.6301 13.5197C18.8201 13.5197 19.0201 13.5098 19.2401 13.5098H26.56C28.91 13.5198 29.5 14.0998 29.5 16.4198Z",
    stroke: "#2D4982",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8201 22.2598H20.1501",
    stroke: "#2D4982",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 22.2598H25.52",
    stroke: "#2D4982",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLinkSupportPunish);
export default __webpack_public_path__ + "static/media/card_link_support_punish.67c7a11469138d4a425a1e23ca4639ca.svg";
export { ForwardRef as ReactComponent };